import { BASE_URL, UPLOAD_ROOT_PATH, zipURL } from '../../utils/Constants';
function formatFileURL(fileUrl) {
  if (!fileUrl) return "";
  return fileUrl.startsWith("http") || fileUrl.startsWith("https")
    ? zipURL !== ""
      ? zipURL + fileUrl.replace(`${UPLOAD_ROOT_PATH}/`, "/").replace("public/", "/").replace(/https?:\/\//, "")
      : fileUrl.replace(`${UPLOAD_ROOT_PATH}/`, "/").replace("public/", "/")
    : (zipURL !== "" ? zipURL + BASE_URL?.replace(/https?:\/\//, "") : BASE_URL) +
      (fileUrl.startsWith("/") ? "" : "/") +
      fileUrl.replace(`${UPLOAD_ROOT_PATH}/`, "/").replace("public/", "/");
}
export default formatFileURL;